export enum PopupmessageTypes{
    ok="ok",
    loading="loading",
    confirm="confirm"
}